export default class Transform {
  k: number;
  x: number;
  y: number;

  constructor(k = 1, x = 0, y = 0) {
    this.k = k;
    this.x = x;
    this.y = y;
  }

  scale(k: number) {
    return k === 1 ? this : new Transform(this.k * k, this.x, this.y);
  }

  translate(x: number, y: number) {
    return x === 0 && y === 0
      ? this
      : new Transform(this.k, this.x + this.k * x, this.y + this.k * y);
  }

  compose(transform: Transform) {
    return new Transform(
      this.k * transform.k,
      this.x + this.k * transform.x,
      this.y + this.k * transform.y,
    );
  }

  inverse() {
    return new Transform(1 / this.k, -this.x / this.k, -this.y / this.k);
  }

  apply(point: [number, number]): [number, number] {
    return [point[0] * this.k + this.x, point[1] * this.k + this.y];
  }

  applyX(x: number) {
    return x * this.k + this.x;
  }

  applyY(y: number) {
    return y * this.k + this.y;
  }

  invert(location: [number, number]): [number, number] {
    return [(location[0] - this.x) / this.k, (location[1] - this.y) / this.k];
  }

  invertX(x: number) {
    return (x - this.x) / this.k;
  }

  invertY(y: number) {
    return (y - this.y) / this.k;
  }

  rescaleX(x: any) {
    return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
  }

  rescaleY(y: any) {
    return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
  }

  toString() {
    return `translate(${this.x},${this.y}) scale(${this.k})`;
  }
}
